<template>
  <dx-popup
    :visible="visible"
    :drag-enabled="false"
    :close-on-outside-click="false"
    :show-title="true"
    :width="500"
    :height="280"
    :show-close-button="false"
    title="Tilføj domæne pengeinstitut"
    @shown="onShown">
    <template #content>
      <form v-if="visible" @submit="handleSubmit($event)">
        <dx-validation-group ref="validationGroup">
          <div class="add-domain-client-form">
            <div class="row">
              Pengeinstitut:
              <dx-select-box
                ref="selectBox"
                :data-source="availableClients"
                :display-expr="displayExpr"
                value-expr="identifier"
                :search-enabled="true"
                :show-clear-button="true"
                :value="selectedClientId"
                @value-changed="(e) => selectedClientId = e.value">
                <dx-validator>
                  <dx-required-rule message="Pengeinstitut skal vælges" />
                </dx-validator>
              </dx-select-box>
            </div>

            <div class="validation-row row">
              <dx-validation-summary />
            </div>

            <div class="button-row row">
              <dx-button text="Tilføj" :use-submit-behavior="true" class="button margin-right" />
              <dx-button text="Annuller" @click="handleCancel" class="button" />
            </div>
          </div>
        </dx-validation-group>
      </form>
    </template>
  </dx-popup>
</template>

<script>
import { ref, computed, watch } from 'vue';

export default {
  name: 'AddDomainClientForm',
  props: {
    visible: Boolean,
    mainClientId: [String, Number],
    clients: Array,
    existingClientIds: Array,
  },
  setup(props, context) {
    const selectedClientId = ref(null);
    const validationGroup = ref(null);
    const selectBox = ref(null);

    const availableClients = computed(() => {
      if (!props.clients) return [];
      const existing = props.existingClientIds || [];
      return props.clients
        .filter((c) => String(c.identifier) !== String(props.mainClientId)
          && !existing.includes(String(c.identifier)))
        .sort((a, b) => a.registrationNumber - b.registrationNumber);
    });

    function displayExpr(item) {
      return item && `${item.registrationNumber} - ${item.name}`;
    }

    function resetForm() {
      selectedClientId.value = null;
      if (validationGroup.value && validationGroup.value.instance) {
        validationGroup.value.instance.reset();
      }
    }

    watch(() => props.visible, (isVisible) => {
      if (isVisible) {
        resetForm();
      }
    });

    const handleSubmit = (e) => {
      e.preventDefault();
      const result = validationGroup.value && validationGroup.value.instance
        ? validationGroup.value.instance.validate()
        : { isValid: !!selectedClientId.value };
      if (!result.isValid) return;
      context.emit('save', selectedClientId.value);
    };

    const handleCancel = () => {
      context.emit('cancel');
    };

    const onShown = () => {
      if (selectBox.value && selectBox.value.instance) {
        selectBox.value.instance.focus();
      }
    };

    return {
      selectedClientId,
      validationGroup,
      selectBox,
      availableClients,
      displayExpr,
      handleSubmit,
      handleCancel,
      onShown,
    };
  },
};
</script>

<style lang="scss" scoped>
.add-domain-client-form {
  display: flex;
  flex-direction: column;

  .row {
    padding-bottom: 15px;
  }

  .button {
    width: 100px;
  }

  .margin-right {
    margin-right: 15px;
  }

  .button-row,
  .validation-row {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
